export default __webpack_public_path__ + "static/media/main-slider-3.4c2a87a4.png";